import React from "react";

const ArrowLeftRightIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>arrow-left-right-icon</title>
      <path
        d="M4.728 10.29c.19.186.296.44.296.706 0 .265-.107.52-.296.706-.398.39-1.036.39-1.433 0L.445 9.058C.16 8.778 0 8.396 0 7.998c0-.4.16-.78.444-1.06l2.85-2.645c.398-.39 1.036-.39 1.434 0 .19.186.296.44.296.707 0 .265-.107.52-.296.706l-1.48 1.29h9.5l-1.48-1.29c-.19-.186-.295-.44-.295-.706 0-.266.106-.52.296-.707.396-.39 1.034-.39 1.43 0l2.852 2.645c.284.28.444.66.444 1.06 0 .398-.16.78-.444 1.06L12.694 11.7c-.397.392-1.035.392-1.432 0-.19-.185-.296-.44-.296-.705 0-.266.106-.52.296-.707l1.48-1.293H3.238l1.49 1.294z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ArrowLeftRightIcon;
